import { useSearchParams } from "react-router-dom";

export const useCustomParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get search parameters as an object
  const getParams = () => {
    return Object.fromEntries(searchParams.entries());
  };

  // Set multiple search parameters at once (removing keys with null, false, or undefined values)
  const setParams = (params) => {
    const newParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== false && value !== undefined) {
        newParams.set(key, value);
      }
    });

    setSearchParams(newParams);
  };

  // Append parameters (or update if it exists), removing if value is null, false, or undefined
  const appendParams = (params) => {
    const newParams = new URLSearchParams(searchParams);

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== false && value !== undefined) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
    });

    setSearchParams(newParams);
  };

  // Reset search params to default values (removing keys with null, false, or undefined values)
  const resetParams = (defaultParams = {}) => {
    const newParams = new URLSearchParams();

    Object.entries(defaultParams).forEach(([key, value]) => {
      if (value !== null && value !== false && value !== undefined) {
        newParams.set(key, value);
      }
    });

    setSearchParams(newParams);
  };

  // Clear all search parameters
  const clearParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return {
    params: getParams(),
    getParams,
    setParams,
    appendParams,
    resetParams,
    clearParams,
  };
};
